import styled from '@emotion/styled';
import { ReactComponent as WhatsAppIconComponent } from 'assets/icons/whatsApp.svg';
import { Colors } from 'styles/variables/colors';
import { Breakpoints } from 'styles/variables/breakpoints';

import { TextStyle } from 'styles/variables/mixins';
const { white, consultationButton, purple, green } = Colors;
const { xs, sm, lg, xl, xxl } = Breakpoints;

export const ChatPrompt = styled.p`
    ${TextStyle({ fontSize: '30px', fontWeight: '700' })}
    @media screen and (max-width: ${xl}) {
        font-size: 26px;
    }
    @media screen and (max-width: ${lg}) {
        font-size: 22px;
    }
    @media screen and (max-width: ${sm}) {
        font-size: 18px;
    }
    @media screen and (max-width: 575px) {
        font-size: 16px;
    }
`;

export const EmailPrompt = styled.p`
    ${TextStyle({ fontSize: '25px', fontWeight: '700' })}
    @media screen and (max-width: ${xl}) {
        font-size: 24px;
    }
    @media screen and (max-width: ${lg}) {
        font-size: 22px;
    }
    @media screen and (max-width: ${sm}) {
        font-size: 18px;
    }
    @media screen and (max-width: 575px) {
        font-size: 16px;
    }
`;

export const EmailContainer = styled.div`
    display: flex;
    gap: 10px;
    @media screen and (max-width: 575px) {
        flex-direction: column;
        gap: none;
    }
`;

export const IFrame = styled.iframe`
    width: 71vw;
    height: 40vw;
    border: none;
    border-radius: 3px;
`;

export const Mailto = styled.a`
    ${TextStyle({ fontSize: '25px', fontWeight: '700', color: consultationButton })}
    text-transform:  none;
    &:hover {
        color: ${purple};
        transition: 0.3s;
    }
    @media screen and (max-width: ${xl}) {
        font-size: 24px;
    }
    @media screen and (max-width: ${lg}) {
        font-size: 22px;
    }
    @media screen and (max-width: ${sm}) {
        font-size: 18px;
    }
    @media screen and (max-width: 575px) {
        font-size: 16px;
    }
`;

export const Or = styled.p`
    ${TextStyle({ fontSize: '20px', fontWeight: '700' })}
    @media screen and (max-width: ${sm}) {
        font-size: 18px;
    }
    @media screen and (max-width: 575px) {
        font-size: 16px;
        font-weight: 600;
    }
`;

export const SupportSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    line-height: 37px;
    font-style: normal;
    text-transform: capitalize;
    line-height: 1.2;
    margin: 2rem 1rem 2rem 1rem;
    @media screen and (max-width: ${xl}) {
        gap: 1.5rem;
    }
    @media screen and (max-width: 575px) {
        gap: 1rem;
    }
`;

export const VideoPrompt = styled.p`
    ${TextStyle({ fontSize: '30px', fontWeight: '700' })}
    max-width: 1160px;
    @media screen and (max-width: ${xl}) {
        font-size: 26px;
    }
    @media screen and (max-width: ${lg}) {
        font-size: 22px;
    }
    @media screen and (max-width: ${sm}) {
        font-size: 18px;
    }
    @media screen and (max-width: 575px) {
        font-size: 16px;
    }
`;

export const WhatsAppButton = styled.a`
    ${TextStyle({ fontSize: '40px', fontWeight: '700', color: white })}
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem 1rem;
    gap: 12px;
    background: ${green};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    line-height: 1;
    @media screen and (max-width: ${xxl}) {
        font-size: 35px;
    }
    @media screen and (max-width: ${xl}) {
        font-size: 30px;
    }
    @media screen and (max-width: ${lg}) {
        font-size: 26px;
        padding: 0.3rem 0.8rem;
        border-radius: 15px;
    }
    @media screen and (max-width: ${sm}) {
        font-size: 22px;
        border-radius: 10px;
    }
    @media screen and (max-width: 575px) {
        font-size: 18px;
        gap: 8px;
    }
    @media screen and (max-width: 510px) {
        font-size: 20px;
        font-weight: 600;
        gap: 8px;
    }
    @media screen and (max-width: ${xs}) {
        font-size: 16px;
    }
`;

export const WhatsAppIcon = styled(WhatsAppIconComponent)`
    width: 50px;
    height: 50px;
    @media screen and (max-width: ${xl}) {
        width: 45px;
        height: 45px;
    }
    @media screen and (max-width: ${lg}) {
        width: 40px;
        height: 40px;
    }
    @media screen and (max-width: ${sm}) {
        width: 35px;
        height: 35px;
    }
    @media screen and (max-width: 575px) {
        width: 30px;
        height: 30px;
    }
`;

export const ShowLP = styled.div`
    display: none;
    @media screen and (max-width: 510px) {
        display: unset !important;
        padding-bottom: 40px;
    }
`;
export const HideLP = styled.div`
    @media screen and (max-width: 510px) {
        display: none;
    }
`;
